import { useParams } from 'react-router';
import { Card } from 'reactstrap';
import { StudentRiskEvaluationSessionDataLoader } from './loaders/StudentRiskEvaluationSessionDataLoader';
import { StudentRiskEvaluationSessionDetailsLoader } from './loaders/StudentRiskEvaluationSessionDetailsLoader';
import StudentRiskEvaluationSessionFilters from './parts/StudentRiskEvaluationSessionFilters';
import StudentRiskEvaluationSessionsHeader from './parts/StudentRiskEvaluationSessionsHeader';
import StudentRiskEvaluationSessionTable from './parts/StudentRiskEvaluationSessionTable';

const StudentRiskEvaluationSessionStudents = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="mx-3">
      <Card className="p-4">
        <div className="w-100 d-flex flex-wrap justify-content-center">
          <StudentRiskEvaluationSessionDetailsLoader
            defaultQuery={{ sessionId: id }}
            fetchImmediately
          >
            <StudentRiskEvaluationSessionDataLoader
              defaultQuery={{ page: 1, items_per_page: 10, sessionId: id }}
              fetchImmediately
            >
              <StudentRiskEvaluationSessionsHeader />
              <StudentRiskEvaluationSessionFilters />
              <StudentRiskEvaluationSessionTable />
            </StudentRiskEvaluationSessionDataLoader>
          </StudentRiskEvaluationSessionDetailsLoader>
        </div>
      </Card>
    </div>
  );
};

export default StudentRiskEvaluationSessionStudents;
